import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer, SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import { imageUrlBase } from "../../utils"

// constants
const KIOSKS = window.SD_KIOSKS;
const API_KEY = 'AIzaSyBgOO2mVtMpExJzVH973YlqPVBGBQ7hTQk'
const MAP_ID = 'a901bf1b78a9c72d'
let USERS_CORDS = window.SD_USERS_CORDS

// globals
let previousMarker;

// logic
window.addEventListener('load', function () {
  const LISTINGS_ELS = document.getElementById('kiosk-list')
  const NO_RESULTS_EL = document.querySelector(".kiosk-tile.no-results")
  const MAP_HTML_ID = 'map'
  const MAP_EL = document.getElementById(MAP_HTML_ID)
  let searchValue = ''
 // let searchValueWithCountry = ''
  let google = null
  let map = null

  if (LISTINGS_ELS && MAP_EL && KIOSKS) {
    const loader = new Loader({
      apiKey: API_KEY,
      mapId: MAP_ID,
      version: "weekly",
      libraries: ["places"]
    });

    loader.load({ other_params: 'libraries=places' }).then((g) => {
      google = g;

      map = new google.maps.Map(document.getElementById(MAP_HTML_ID), {
        center: USERS_CORDS,
        zoom: 7,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
      });

      const markers = KIOSKS.map((kiosk) => {
        const location = kiosk;
        var iconUrl = `${imageUrlBase}/kiosk-location-pin.png`;
        if (location.kioskType != 1) {
          iconUrl = `${imageUrlBase}/location-pin.png`;
        }
        const marker = new google.maps.Marker({
          map,
          title: location.name,
          position: {
            lat: parseFloat(location.gpsLatitude),
            lng: parseFloat(location.gpsLongitude)
          },
          icon: {           
            url: iconUrl,
            scaledSize: new google.maps.Size(36, 44)
          }
        });


        google.maps.event.addListener(marker, 'click', () => {
          const lat = marker.position.lat()
          const lng = marker.position.lng()

          // set as active
          marker.setIcon(`${imageUrlBase}/location-pin-selected.png`);

          if (previousMarker) {
            previousMarker.setIcon(`${imageUrlBase}/location-pin.png`);
          }

          // unselect if selecting the same marker
          if (previousMarker && previousMarker.title === marker.title) {
            marker.setIcon(`${imageUrlBase}/location-pin.png`);
            previousMarker = null
          } else {
            previousMarker = marker
          }

          if (!previousMarker) {
            [...LISTINGS_ELS.children].forEach((lEl) => {
              lEl.classList.remove('hidden')
            })

            searchKioskList(searchValue)
          }

          if (previousMarker) {
            [...LISTINGS_ELS.children].forEach((lEl) => {
              lEl.classList.add('hidden')
            })

            const tile = document.querySelector(`[data-lat^='${lat}'][data-lng^='${lng}']`)

            if (tile) {
              tile.classList.remove('hidden')
            }
          }
        })

        return marker;
      })

      const renderer = {
        render: ({ count, position }) =>
          new google.maps.Marker({
            label: { text: String(count), color: "#000", fontSize: "14px", fontWeight: "800" },
            position,
            icon: `${imageUrlBase}/location-pin-white.png`,
            // adjust zIndex to be above other markers
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          }),
      };

      const algorithm = new SuperClusterAlgorithm({
        radius: 128,
        maxZoom: 12
      });

      new MarkerClusterer({ map, markers, algorithm, renderer });
    });
  }

  const LOCATION_BUTTON = document.getElementById('get-location-button')
  if (LOCATION_BUTTON) {
    LOCATION_BUTTON.addEventListener('click', async (e) => {
      const position = await getLocation()
      if (position) {
        map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
        map.setZoom(13)
        getClosest({ lat: position.coords.latitude, lng: position.coords.longitude }).then((closest) => {
          if (!closest)
            NO_RESULTS_EL.classList.remove('hidden')
          showClosest(closest);
        })
      }
      e.target.name = "get-location-button";
      window.SD_HandleSearch(e);

    })
  }

  // when a user searches, we pin a marker to their searched location
  // we need to remove it after every search otherwise maps keeps adding pins
  let searchMarker;

  function getLocationByAddress(address) {
    return new Promise((resolve, reject) => {
      var service = new google.maps.places.PlacesService(map);
      const request = {
        query: address,
        fields: ['name', 'geometry']
      }

      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve({ lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() });
        }
        reject();
      });
    });
  }

  // search input handlers
  window.SD_HandleSearch = (e) => {
    e.preventDefault()
    const name = e.target.name;
    const keyCode = e.keyCode;

    const isEnter = keyCode === 13
    const isSearchInput = name === 'search-input'
    const isSearchButton = name === 'search-button'

    if (isSearchInput) {
      searchValue = e.target.value;
    }

    // search the map and center
    if (isEnter || isSearchButton) {
      searchKioskList(searchValue)

      var service = new google.maps.places.PlacesService(map);
    //  const country = window.SD_CULTURE_INFO.countryName.toLowerCase();
    //  searchValueWithCountry = `${searchValue}, ${country}`;

      const request = {
        query: searchValue,
        fields: ['name', 'geometry', 'type']
      }

      // search the kiosk, focus the map and a marker
      service.findPlaceFromQuery(request, function (results, status) {
        // remove previous search marker
        if (searchMarker) {
          searchMarker.setMap(null);
        }

        // add new search marker
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (var i = 0; i < results.length; i++) {
            const place = results[i];
            if (!place.geometry || !place.geometry.location) return;

            searchMarker = new google.maps.Marker({
              map: map,
              position: place.geometry.location,
              // icon: `${imageUrlBase}/location-pin-transparent.png`
            });

            break;
          }

          let mapZoom = 13;
          if (results[0].types.includes('country')) {
            mapZoom = 6;
          }
          map.setZoom(mapZoom);
          map.setCenter(results[0].geometry.location);
        }
      });


    }
  }

  function searchKioskList(value) {
    // narrow down kiosk ui list
    let resultsCount = 0;
    value = value.toLowerCase();

    NO_RESULTS_EL.classList.add('hidden');

    KIOSKS.forEach((kiosk) => {
      const current = LISTINGS_ELS.querySelector(`.kiosk-tile[data-id='${kiosk.id}']`);
      if (typeof(current) !== 'undefined' && current !== null) {
        if (current.classList !== null) {
          current.classList.add('hidden')
        }
      }
      const searchOn = (kiosk.name + kiosk.address + kiosk.city + kiosk.country + kiosk.postalCode).toLowerCase()

      if (searchOn.includes(value)) {
        if (current) {
          current.classList.remove('hidden');
          current.querySelector(".kiosk-tile-distance").innerHTML = '';
          resultsCount++;
        }
      }
    })

    if (resultsCount == 0) {
      const country = window.SD_CULTURE_INFO.countryName.toLowerCase();
      if (!value.includes(country))
        value = `${value}, ${country}`;

      getLocationByAddress(value).then((result) => {
        getClosest(result).then((closest) => {
          if (!closest)
            NO_RESULTS_EL.classList.remove('hidden')
          showClosest(closest);
        })
      }, () =>
        // ZERO RESULTS
        NO_RESULTS_EL.classList.remove('hidden')
      );
    }
  }

  function showClosest(closest) {
    const kioskEls = LISTINGS_ELS.children;
    KIOSKS.forEach((kiosk, index) => {
      const current = kioskEls[index];
      if (typeof(current) !== 'undefined' && current !== null) {
        if (current.classList !== null) {
          kioskEls[index].classList.add('hidden')
        }
      }

    });

    if (closest) {
      closest.forEach((current, index) => {
        if (LISTINGS_ELS !== null) {
           const kiosk = LISTINGS_ELS.querySelector(`.kiosk-tile[data-id='${current.id}']`);
        if (kiosk !== 'undefined' && kiosk !== null) {
          kiosk.querySelector(".kiosk-tile-distance").innerHTML = current.distance;
          kiosk.classList.remove('hidden');
          const nodeBefore = LISTINGS_ELS.querySelector(`.kiosk-tile:nth-child(${index + 1})`);
          LISTINGS_ELS.insertBefore(kiosk, nodeBefore);
        }
      }
      })
    }
  }

})

function getClosest(location) {
  const siteUrl = window.SD_SITE_URL ?? 'https://wa-prod-sushidaily-hkeqaebfdwftggam.uksouth-01.azurewebsites.net/';
  const culture = window.SD_CULTURE_INFO ? window.SD_CULTURE_INFO.culture : 'en-gb';
  if (!siteUrl)
    return;
  return fetch(`${siteUrl}umbraco/api/kioskapi/GetClosest?culture=${culture}&lat=${location.lat}&lon=${location.lng}`, {
    method: 'GET' // *GET, POST, PUT, DELETE, etc.
  }).then((res) => {
    return res.json()
  })
}

function getLocation() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        resolve(position);
      });
    } else {
      reject()
    }
  })
}

